import { NotifyHelper } from "../../../helpers/toast";
import { eKhongDuDieuKienKetQuaHocTapXetTotNghiepActionsObj } from "../../action-types/xet-tot-nghiep/IKhongDuDieuKienKetQuaHocTapXetTotNghiepActions";
import { generateActionForKey, generateActions } from "../generateActions";

export const khongDuDieuKienKetQuaHocTapXetTotNghiepActions = {
    ...generateActions(eKhongDuDieuKienKetQuaHocTapXetTotNghiepActionsObj, "KHONG_DU_DIEU_KIEN_KET_QUA_HOC_TAP_XET_TOT_NGHIEP"),
    ...generateActionForKey(eKhongDuDieuKienKetQuaHocTapXetTotNghiepActionsObj, "KHONG_DU_DIEU_KIEN_KET_QUA_HOC_TAP_XET_TOT_NGHIEP", "LOAD_BY_DOT_XET_ERROR", (message) => {
        NotifyHelper.Error(message);
    }),
}